
import { Component, OnInit } from '@angular/core';
import { BpgAdminServices } from '../../bpg-admin/bpg-admin-services';
import { SelfService } from '../../bpg-self-services/self-services.service.ts';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LandingPaginationDTO} from "../../bpg-common/services/data.services";
import { ConstantValues } from '../../bpg-common/models/bpg-constants';
import { Router } from '@angular/router';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';
import { BpgCommonService } from 'src/app/bpg-common/services/bpg-common.service';


@Component({
  selector: 'app-email-management',
  templateUrl: './email-management.component.html',
  styleUrls: ['./email-management.component.css']
})
export class EmailManagementComponent implements OnInit {
  LandingPaginationDTO: LandingPaginationDTO = new LandingPaginationDTO();
  landingDto: any;
  adminData: any;
  userList: any;
  name: any;
 email : any;
  emailflag: any;
  workId: any;
  division : any;
  site : any;
  user: string = null;
  role: string = null;
  roleName: string = null;
  userFirstName: string = null;
  noDataFound: boolean;
  alertSuccess: boolean;
  alertFailure: boolean;
  alertError: boolean;
  deleteSuccess: boolean;
  errorMsg: any;
  msg1: string;
  method: string;
  param: string;
  loginData: any = JSON.parse(localStorage.getItem("loginData"));;
  loginUserId: any = this.loginData['userId'];
  chapterId: any;
  createdBy: any;
  createdDateTime: any;
  modifiedBy: any;
  modifiedDateTime: any;
  userId: any;
  adminId: any = localStorage.getItem('adminId');
  nonAdmin  = true;
  numberOfElements:number;
  currentPage = 0;
  currentNumberOfElements:number = ConstantValues.pageLimit;
  totalPages = 0;
  roleList : any;
  tableShow: any;
  limit: number = ConstantValues.pageLimit;
  currentShowingElements: number = ConstantValues.pageLimit;
  searchKey: any;
  searchTerm : any;
  noUser : boolean;
  userFound : boolean;
  search : boolean;
  loginDetails: any = JSON.parse(localStorage.getItem("loginData"));
  timeOutError: boolean;
  timeoutErrorMessage : string = ConstantValues.timeoutErrorMessage;
  isbpgAdmin = false;
  isbpgLeadAdmin = false;

  constructor(private readonly  userService: SelfService, 
              private readonly  adminService: BpgAdminServices, 
              private readonly  spinner: Ng4LoadingSpinnerService,
              private readonly bpgCommonService: BpgCommonService,
              private readonly router: Router,
              private readonly environment : EnvironmentConfiguration
              ){ }

  ngOnInit() {
    if(this.environment.envName === 'dev' || this.environment.envName === 'qa' || this.environment.envName === 'prod'){
 if(localStorage.getItem('loginData') === null || localStorage.getItem('loginData') === undefined ){
      this.router.navigate(['/log-out']);
      }
    }

    if (localStorage.getItem('logOutFlag') === "true"){
        this.router.navigate(['/log-out']);      
    }
    localStorage.removeItem('searchedEventsCaledarItems');
    this.logUserAction();
    if(localStorage.getItem('isbpgAdmin') === 'true')
    {
      this.isbpgAdmin = true
   }
   if(localStorage.getItem('isbpgLeadAdmin') === 'true')
    {
      this.isbpgLeadAdmin = true
   }
    this.spinner.show();
    if(this.adminId === "1" || this.adminId === "2" || this.adminId === "3" || this.isbpgAdmin || this.isbpgLeadAdmin)
    {
    this.nonAdmin = false;
    }
    if(this.nonAdmin)
   {
    this.name = `${this.loginDetails.userFirstName} ${this.loginDetails.userLastName}`;
    this.email = this.loginDetails.emailId ;
    this.workId = this.loginDetails.workdayId;
    this.division = this.loginDetails.division;
    this.site = this.loginDetails.site.siteName;
    this.userId = this.loginDetails.userId;
   } 
   if(this.nonAdmin)

   {
   if((this.email.endsWith('@toyota.com')) || (this.email.endsWith('@lexus.com')) || (this.email.endsWith('@scion.com') ))
    {this.emailflag=false;
    }
    else{
    this.emailflag=true; 
    }
    }


    sessionStorage.removeItem("MembershipData");
    
    this.landingDto = {
      "filter": { },
      "moduleId": 0,
      "page": 0,
      "presentRole": "string",
      "searchTerm": "",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "string",
      "uid": "string"
    }

    this.LandingPaginationDTO.sortProperty = "user_first_name";
    this.LandingPaginationDTO.size = ConstantValues.pageLimit;
    this.LandingPaginationDTO.sortDirection = "ASC";


 this.spinner.show();

    this.loginData = JSON.parse(localStorage.getItem('loginData'));
    this.createdBy = this.loginData.userId;
    this.modifiedBy = this.loginData.userId;

    this.createdDateTime = new Date();
    this.modifiedDateTime = new Date();


    this.loginUserId = this.loginData.userId;
    
    setTimeout(function () {
      this.spinner.hide();
    }.bind(this), 500);
  }
  findbyEmail(e){
    const text = e.target.value;
    if(text.length>2){
     this.searchTerm = text;
     this.searchBy();
    }else{
      this.userList = [];
    }
  }

  /** to list admins in table
  * @class AdminComponent
  * @method listAdmins
  */
 

  

  /** to list users other than admins
  * @class AdminComponent
  * @method getUserList
  */

  getUserList() {
    this.timeOutError = false;
    this.landingDto.filter = {};
    this.landingDto.filter.leadershipPosition =  "USER";
    this.landingDto.filter.flag = "EMAILMANAGEMENT";
    this.userService.getUserDropDown(this.landingDto).subscribe(data => {
      this.userList = data;
     
      if(this.userList.length === 0 && this.nonAdmin===false){
        setTimeout(() => {    
          window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        },500);
        this.noUser = true;
        if(this.deleteSuccess === true  ){
          this.noUser = false;
        }
        this.userFound = false; 
      } else{   
        if(this.search){
          setTimeout(() => {    
            window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
          },500);
        this.userFound = true; 
        this.noUser = false;
        } 
      this.userList.map((i) => { i.userFirstName = `${i.userFirstName} ${i.userLastName}`; return i; })
      }   


    }, err => {
      if(err.value.statusText === ConstantValues.unknownError){
        this.timeOutError = true;
      }
    });
  }

  /** When select a user Populate the user details such as email and workId 
* @class AdminComponent
* @method getUserList
*/

  userSelection(user) {
  
    for (const userList of this.userList) {

      if (userList != null) {
        if (user.userId === userList.userId) {
          this.userId = userList.userId;
          this.name = userList.userFirstName;
          this.email = userList.emailId;
          this.workId = userList.workdayId;
          this.division = userList.division;
          this.site = userList.site.siteName;
        }
      }
      this.userFound = false;
    }
    if((this.email.endsWith('@toyota.com')) || (this.email.endsWith('@lexus.com')) || (this.email.endsWith('@scion.com') ))
      {this.emailflag=false;
       }
    else{
      this.emailflag=true; 
    }
  }
/**to submit Email
  * @class AdminComponent
  * @method submit
  */

 submit() {
  this.timeOutError = false;
  this.email = document.getElementById("email");
   this.email = this.email.value;
  const landingData = {     
    "createdBy": this.createdBy,
    "createdDateTime": this.createdDateTime,
    "isActive": true,
    "modifiedBy": this.modifiedBy,
    "modifiedDateTime": this.modifiedDateTime,
    "userId": this.userId,
    "emailId": this.email,
   
  }
  this.adminService.updateEmail(landingData).subscribe(data => {
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    if (data != null && data.body.message === undefined) {
      this.alertSuccess = true;
      this.search = false;        
    }
  
    else if( data.body.message !== undefined) {
      this.errorMsg = data.body.message.split(":")[0];
      this.alertFailure = true;
      this.search = false;   
    }
    else{
      this.alertError = true;
    }   

    this.getUserList();
  },
  err => {
    if(err.value.statusText === ConstantValues.unknownError){
      this.timeOutError = true;
    }
  }); 

}

  /** to update Email
  * @class AdminComponent
  * @method UpdateEmail
  */
  onSubmit() {
    this.clearError();     
    this.method = "submit";
    this.param = '';
    this.msg1 = "Are you sure you want to update email address of the user?";
  }

  /**to delete admin
  * @class AdminComponent
  * @method delete
  */


  resetClick(){
    this.noDataFound =false;
    this.method = "resetAdmin";
    this.param = '';
    this.msg1 = "Your current changes will be discarded. Do you want to continue ?";
  }

  /** For resetting the skill form
   * @method resetSkill
   */
  resetAdmin() {
    this.userFirstName = null;   
    this.roleName = null;   
    this.name = '';     
    this.email = '';    
    this.workId = ''; 
    this.division = '';
    this.emailflag = false;
    this.site = '';
    this.searchTerm=null;
    this.LandingPaginationDTO.searchTerm = '';
    this.searchKey =null;
    this.clearError();
  }



  /** For filtering data by current page 
   * @class AdminComponent
   * @method pageChanged
   * @params event
   */
  pageChanged(event) {
    this.clearError();
    this.LandingPaginationDTO.page = event - 1;
    this.currentPage = event;

    if ((this.currentPage * this.limit) < this.numberOfElements) {
      this.currentShowingElements = this.currentPage * this.limit;
    } else if ((this.currentPage * this.limit) >= this.numberOfElements) {
      this.currentShowingElements = this.numberOfElements;
    }
  }

    /** For sorting the table through columns
   * @class AdminComponent
   * @method sortMe
   */

  public sortMe(sortingby) {
    this.clearError();
    if (this.LandingPaginationDTO.sortDirection === "ASC") {
      this.LandingPaginationDTO.sortDirection = "DESC";
      document.getElementById(sortingby + "1").classList.add("fading");
      document.getElementById(sortingby + "2").classList.remove("fading");
    } else {
      this.LandingPaginationDTO.sortDirection = "ASC";
      document.getElementById(sortingby + "2").classList.add("fading");
      document.getElementById(sortingby + "1").classList.remove("fading");
    }

    this.LandingPaginationDTO.sortProperty = sortingby;
  }

     /** For searching the table through keywords
   * @class AdminComponent
   * @method searchMe
   */
  searchMe() {  
    this.clearError();
    this.searchKey = (this.searchKey) ? this.searchKey : '';
    this.LandingPaginationDTO.page = 0;
    this.LandingPaginationDTO.searchTerm = this.searchKey;
    this.currentPage = 1;
  }

     /** For searching the table through search term
   * @class AdminComponent
   * @method searchBy
   */
  searchBy() {
    this.deleteSuccess = false;

    this.clearError();
    this.spinner.show(); 
    this.search = true;  
    this.searchTerm = (this.searchTerm) ? this.searchTerm : '';
    this.landingDto.searchTerm = this.searchTerm;
    this.getUserList();    
    this.spinner.hide();   
  }

   /** For clearing errors
   * @class AdminComponent
   * @method clearError
   */
  clearError() {
    this.noUser = false;
    this.alertSuccess = false;
    this.alertFailure = false;
    this.deleteSuccess = false;
    this.userFound = false; 
    this.alertError = false;
    this.noDataFound = false;
  }

  logUserAction() {
    const data = {
      userId : this.loginUserId,
      categoryDescription : "Email Management Screen"
    };
    this.bpgCommonService.logUserAction(data).subscribe(
      (_data) => {});
  }

}

